<template>
  <li class="item" :class="'item' + num" >
    <slot />
  </li>
</template>
<script>
export default {
    data(){
        return{

        }
    },
    props:{
        num:{
            type:Number
        },
        id:{
            type:Number
        }
    },
    mounted(){
       
    }
}
</script>
<style scoped>
  .item {
    margin: 10px 0;
    padding: 0 10px;
    border-radius: 4px;
    list-style: none;
    color: #404A5B;
    text-align: left;
  }
  .item1{
      color: #0090FF;
      font-weight: bold;
      font-size: 18px;
  }
  .item2{
      color: #0090ff;
      font-weight: normal;
  }
  .item3{
      color: rebeccapurple;
      font-size: 16px;
  }
  .item3 i{
      opacity: 0;
  }
</style>


// WEBPACK FOOTER //
// src/components/assembly/menu/Menuitem.vue